<template>
  <div class="modal fade" id="dashboardCrewModal" tabindex="-1" aria-labelledby="dashboardCrewModal" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="dashboardCrewModal">
              {{ crewActivityStatus }}
            <template v-if="manning">
              {{ manning.alias.charAt(0).toUpperCase() + manning.alias.slice(1).toLowerCase() }}
            </template>
              Crew
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-10 form-row justify-content-around">
              <div v-if="crewActivityStatus !== 'Total'" class="form-group col-sm-5 row">
                <label for="date-from" class="col-sm-2 col-form-label font-weight-bold text-smaller">
                  From:
                </label>
                <div class="col-sm-10">
                  <input type="date" id="date-from" class="form-control form-control-xs" v-model="filter.dateFrom">
                </div>
              </div>
              <div v-if="crewActivityStatus !== 'Total'" class="form-group col-sm-5 row">
                <label for="date-to" class="col-sm-2 col-form-label font-weight-bold text-smaller">
                  To:
                </label>
                <div class="col-sm-10">
                  <input type="date" id="date-to" class="form-control form-control-xs" v-model="filter.dateTo">
                </div>
              </div>
              <div class="form-group col-sm-5 row">
                <label for="vessel" class="col-sm-2 col-form-label font-weight-bold text-smaller">Vessel:</label>
                <div class="col-sm-10">
                  <select class="form-control form-control-xs" id="vessels" v-model="filter.vesselID">
                    <option :value="null">---Select Vessel---</option>
                    <option v-for="vessel in vessels" :key="vessel.id" :value="vessel.id">
                      {{vessel.name}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group col-sm-5 row">
                <label for="rank" class="col-sm-2 col-form-label font-weight-bold text-smaller" >Rank:</label>
                <div class="col-sm-10">
                  <select class="form-control form-control-xs" id="rank" v-model="filter.rankID">
                    <option :value="null">---Select Rank---</option>
                    <option v-for="rank in ranks" :key="rank.id" :value="rank.id" :title="rank.name">
                      {{rank.alias}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-2">
              <button class="btn btn-sm btn-secondary" @click="getCrews">
                <span class="fas fa-search"></span>
              </button>
              <button class="btn btn-sm btn-outline-danger ml-1 font-weight-bolder"
                  @click="printPDFCrews"
                  :disabled="isDownloading"
              >
                <i  class="fas fa-file-pdf text-danger"></i>
              </button>
               <button class="btn btn-sm btn-outline-success ml-1 font-weight-bolder"
                  @click="printExcelCrews"
                  :disabled="isDownloading"
              >
                <i  class="fas fa-file-excel text-success"></i>
              </button>
            </div>
          </div>


          <div class="text-left">
            <small v-if="pagination.from == null">{{ `No Records found` }}</small>
            <small v-else>{{ `${pagination.from} to ${pagination.to} of ${pagination.total}` }}</small>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">No</th>
                <th scope="col">Family name, given names</th>
                <th scope="col">Rank or rating	</th>
                <th scope="col">Nationality</th>
                <th scope="col">Date and place of birth</th>
                <th scope="col">Passport Number and Expiry Date</th>
                <th scope="col">Seaman's Book and Expiry Date</th>
                <th scope="col">Embarkation Date and Place</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="8" class="text-center">Loading...</td>
              </tr>
              <tr v-else v-for="(crew, index) in crews" :key="crew.id">
                <th scope="row">{{ index + pagination.from }}</th>
                <td>
                  <router-link :to="{name: 'CrewActivity',params: {id:crew.id}}" target="_blank">
                    {{ crew.fullName }}
                  </router-link>
                </td>
                <td>{{ crew.rankName }}</td>
                <td>{{ crew.nationality }}</td>
                <td>
                  <div v-if="crew.birthDate">{{ crew.birthDate }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                  <br />

                   <div v-if="crew.birthPlace">{{ crew.birthPlace }}</div>
                   <div v-else class="text-danger">NO DATA</div>
                </td>
                <td>
                  <div v-if="crew.passportNumber">{{ crew.passportNumber }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                  <br />

                  <div v-if="crew.passportExpiryDate">{{ crew.passportExpiryDate }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                </td>
                <td>
                  <div v-if="crew.seamanBookNumber">{{ crew.seamanBookNumber }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                  <br />

                  <div v-if="crew.seamanBookExpiryDate">{{ crew.seamanBookExpiryDate }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                </td>
                <td>
                  <div v-if="crew.embarkationDate">{{ crew.embarkationDate }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                  <br />

                  <div v-if="crew.embarkationPlace">{{ crew.embarkationPlace }}</div>
                  <div v-else class="text-danger">NO DATA</div>
                </td>
              </tr>
            </tbody>
          </table>
          <nav aria-label="...">
            <ul class="pagination text-smallest justify-content-center">
              <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                <button class="page-link" @click="page = 1">First</button>
              </li>

              <li v-for="_page in paginationPages" :key="_page" class="page-item"
                  :class="{ 'disabled': _page === '...', 'active': _page === pagination.currentPage }">
                <button class="page-link" @click="page = _page">{{ _page }}</button>
              </li>

              <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                <button class="page-link" @click="page = pagination.lastPage">Last</button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { paginationMixin } from "@/mixins/paginationMixin";
import axios from "axios";
import {FileService} from "@/services/FileService";
import Swal from "sweetalert2";

export default {
  name: "DashboardCrewModal",
  mixins: [paginationMixin],
  props: {
    manning: {
      type: Object,
      required: false
    },
    crewActivityStatus: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      page: 1,
      crews: [],
      filter: {
        dateFrom: "",
        dateTo: "",
        rankID: null,
        vesselID: null
      },
      isLoading: false,
      isDownloading: false
    }
  },
  async created() {
    await this.getVesselKeys()
    await this.getRankKeys()
  },
  computed: {
    ...mapGetters({
      vessels: 'vesselKeys',
      ranks: 'rankKeys',
    })
  },
  methods: {
    ...mapActions([
      'getVesselKeys',
      'getRankKeys',
      'setPagination',
    ]),
    async getCrews() {
      this.isLoading = true

      const response = await axios({
        url: '/cms/dashboardCrewList',
        method: 'get',
        params: {
          page: this.page,
          dateFrom: this.filter.dateFrom,
          dateTo: this.filter.dateTo,
          vessel: this.filter.vesselID,
          rank: this.filter.rankID,
          manning: this.manning.id,
          crewActivityStatus: this.crewActivityStatus,
        }
      })

      this.crews = response.data.crews.data
      this.setPagination(response.data.crews)

      this.isLoading = false
    },
    async printExcelCrews() {
      this.isDownloading = true

      Swal.fire({
        title: "Downloading..",
        imageUrl: require('@/assets/loading.gif'),
        imageWidth: 100,
        imageHeight: 50,
        imageAlt: 'Custom image',
        showConfirmButton: false,
        scrollbarPadding: false,
        allowOutsideClick: false
      });

      const response = await axios({
        url: '/cms/dashboardCrewListPrint',
        method: 'get',
        responseType: 'blob',
        params: {
          vessel: this.filter.vesselID,
          rank: this.filter.rankID,
          dateFrom: this.filter.dateFrom,
          dateTo: this.filter.dateTo,
          manning: this.manning.id,
          crewActivityStatus: this.crewActivityStatus,
        }
      })

      const dateNow = new Intl.DateTimeFormat('en-US').format(new Date()).replace(/\//g, '-')
      const manning = this.manning.alias.toLowerCase().replace(/ /g, "-")
      const fileName = `${this.crewActivityStatus.toLowerCase()}-list_${manning}_${dateNow}.xlsx`

      Swal.fire({
        title: "Download Successful!",
        icon: "success",
        showConfirmButton: false,
        showCloseButton: true,
      })

      FileService.downloadDocument(response, fileName)
      this.isDownloading = false
    },
    async printPDFCrews() {
      this.isDownloading = true

      Swal.fire({
        title: "Downloading..",
        imageUrl: require('@/assets/loading.gif'),
        imageWidth: 100,
        imageHeight: 50,
        imageAlt: 'Custom image',
        showConfirmButton: false,
        scrollbarPadding: false,
        allowOutsideClick: false
      });

      const response = await axios({
        url: '/cms/dashboardCrewListPrint',
        method: 'get',
        responseType: 'blob',
        params: {
          type: "PDF",
          vessel: this.filter.vesselID,
          rank: this.filter.rankID,
          dateFrom: this.filter.dateFrom,
          dateTo: this.filter.dateTo,
          manning: this.manning.id,
          crewActivityStatus: this.crewActivityStatus,
        }
      })

      const dateNow = new Intl.DateTimeFormat('en-US').format(new Date()).replace(/\//g, '-')
      const manning = this.manning.alias.toLowerCase().replace(/ /g, "-")
      const fileName = `${this.crewActivityStatus.toLowerCase()}-list_${manning}_${dateNow}.pdf`

      Swal.fire({
        title: "Download Successful!",
        icon: "success",
        showConfirmButton: false,
        showCloseButton: true,
      })

      FileService.downloadDocument(response, fileName)
      this.isDownloading = false
    }
  },
  watch: {
    page() {
      this.getCrews()
    },
    manning() {
      this.filter = {
        dateFrom: "",
        dateTo: "",
        rankID: null,
        vesselID: null
      }

      this.getCrews()
    },
    crewActivityStatus() {
      this.filter = {
        dateFrom: "",
        dateTo: "",
        rankID: null,
        vesselID: null
      }

      this.getCrews()
    },
  },
}
</script>
.
